import { supabase } from '../supabaseClient';
import { throttleSupabaseQuery } from '../../utils/requestThrottler';

export class CountryService {
  static async getCountries() {
    try {
      const { data, error } = await supabase
        .from('countries')
        .select('*')
        .order('sort_order');

      if (error) throw error;
      return data;
    } catch (error) {
      console.warn('Countries table not available yet:', error.message);
      return [];
    }
  }

  static async createCountry(countryData) {
    try {
      const { data, error } = await supabase
        .from('countries')
        .insert([countryData])
        .select()
        .single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error creating country:', error);
      throw error;
    }
  }

  static async updateCountry(id, updates) {
    try {
      const { data, error } = await supabase
        .from('countries')
        .update(updates)
        .eq('id', id)
        .select()
        .single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error updating country:', error);
      throw error;
    }
  }

  static async deleteCountry(id) {
    try {
      const { error } = await supabase
        .from('countries')
        .delete()
        .eq('id', id);

      if (error) throw error;
      return true;
    } catch (error) {
      console.error('Error deleting country:', error);
      throw error;
    }
  }

  static async getCountriesThrottled() {
    return throttleSupabaseQuery(
      async () => {
        const { data, error } = await supabase
          .from('countries')
          .select('*')
          .order('sort_order');

        if (error) throw error;
        return data;
      },
      'get_countries',
      {
        retries: 2,
        useCache: true,
        cacheTimeout: 3 * 60 * 1000 // 3 minutes
      }
    );
  }
}
